import { Component, OnInit, ViewChild } from '@angular/core';
import { AppStateService } from '../services/app-state.service';
import { MultiAuthService } from '../services/multi-auth-service';
import { TranslationService } from 'src/app/online-essay/services/translation-service.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-online-essay-layout',
  templateUrl: './online-essay-layout.component.html',
  styleUrl: './online-essay-layout.component.scss'
})
export class OnlineEssayLayoutComponent {
 // Reference to the currently activated child component
 activatedComponent: any;

 // Control button visibility in the parent
 showBackButton = false;
 showNextButton = false;

 // Called whenever a new component is activated in the router-outlet
 onActivate(component: any) {
   this.activatedComponent = component;

   // If the child emits an event to change Back button visibility, subscribe
   if (component.backButtonVisibleChange) {
     component.backButtonVisibleChange.subscribe((isVisible: boolean) => {
       this.showBackButton = isVisible;
     });
   }

   // Similarly for the Next button
   if (component.nextButtonVisibleChange) {
     component.nextButtonVisibleChange.subscribe((isVisible: boolean) => {
       this.showNextButton = isVisible;
     });
   }
 }
  
  constructor(
    private translate: TranslationService,
    public multiAuthService: MultiAuthService
  ) {

  }

  changeLanguage(event: any) {
    const lang = event.target.value;
    this.translate.setLanguage(lang);
  }

  

  // When Button 1 is clicked, call the method on the activated child component
  handleButton1() {
    const component = this.activatedComponent
    if (component && component.handleButton1) {
      component.handleButton1();
    } else {
      console.warn('handleButton1 is not defined on the active component.');
    }
  }

  // Similarly for Button 2
  handleButton2() {
    const component = this.activatedComponent
    console.log(component);
    if (component && component.handleButton2) {
      component.handleButton2();
    } else {
      console.warn('handleButton2 is not defined on the active component.');
    }
  }
}
